import { checkIfResponseSuccess, getItem } from 'owa-mail-store';
import Item from 'owa-service/lib/contract/Item';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import MeetingRequestMessage from 'owa-service/lib/contract/MeetingRequestMessageType';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { action } from 'satcheljs/lib/legacy';

let updateItemAttendees = function updateItemAttendees(originalItem: Item, responseItem: Item) {
    const existingItem: MeetingRequestMessage = originalItem;
    const newItem: MeetingRequestMessage = responseItem;
    existingItem.RequiredAttendees = newItem.RequiredAttendees;
    existingItem.OptionalAttendees = newItem.OptionalAttendees;
};

updateItemAttendees = action('updateItemAttendees')(updateItemAttendees);

export default async function loadAllRecipientsForItem(item: Item): Promise<void> {
    const itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
        MaximumRecipientsToReturn: 0,
        AdditionalProperties: [
            propertyUri({ FieldURI: 'RequiredAttendees' }),
            propertyUri({ FieldURI: 'OptionalAttendees' }),
        ],
    });

    const response = await getItem([item.ItemId.Id], itemShape, null /*shapeName*/);
    if (checkIfResponseSuccess(response[0])) {
        const responseItem = response[0] as ItemInfoResponseMessage;
        updateItemAttendees(item, responseItem.Items[0]);
    }
}
